import http from "./HttpService";

var endpoint = `/reporting/analytics/events/`;

const headers = {};

const getRace = async (year, filterId, filterType = "venue", percentage = false) => {
  const response = await http.get(`${endpoint}participant/race/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
    return response;
};

const getGender = async (year, filterId, filterType = "venue", percentage = false) => {
  const response = await http.get(`${endpoint}participant/gender/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
    return response;
};

const getDisability = async (year, filterId, filterType = "venue", percentage = false) => {
    const response = await http.get(`${endpoint}participant/disability/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
   
      return response;
  };

const getAge = async (year, filterId, filterType = "venue", percentage = true) => {
    const response = await http.get(`${endpoint}participant/age-group/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
      return response;
  };

const getParticipationType = async (year, filterId, filterType = "venue", percentage = true) => {
  const response = await http.get(`${endpoint}participant/type/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
      return response;
  };

const getProvincialDistribution = async (year, filterId, filterType = "venue", percentage = true) => {
  const response = await http.get(`${endpoint}distribution/provincial/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
  return response;
};

const getMunicipalDistribution = async (year, filterId, filterType = "venue", percentage = true) => {
  const response = await http.get(`${endpoint}distribution/municipal/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
  return response;
};

const getProvincialParticipation = async (year, filterId, filterType = "venue", percentage = true) => {
  const response = await http.get(`${endpoint}participant/origin/provincial/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
  return response;
};

const getProvincialParticipationCount = async (year, filterId, filterType = "venue", percentage = false) => {
  const response = await http.get(`${endpoint}participant/origin/provincial/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
  return response;
};

const getMunicipalParticipation = async (year, filterId, filterType = "venue", percentage = true) => {
  const response = await http.get(`${endpoint}participant/origin/municipal/${year}/${filterId}?filterType=${filterType}&percentage=${percentage}`);
  return response;
};

const getYearRange = async () => {
  const response = await http.get(`${endpoint}year-range`);
  return response;
};

const getEvents = async (year) => {
  const response = await http.get(`${endpoint}${year}`);
    return response;
};

const getProvinces = async () => {
  const response = await http.get(`${endpoint}location/provinces`);
    return response;
};

const getEventLocations = async (year, provinceId) => {
  const response = await http.get(`${endpoint}location/marker/${year}/${provinceId}`);
  return response;
};

export default {
    getRace,
    getParticipationType,
    getGender,
    getDisability,
    getAge, 
    getProvincialDistribution,
    getMunicipalDistribution,
    getProvincialParticipation,
    getMunicipalParticipation,
    getYearRange,
    getEvents,
    getProvincialParticipationCount,
    getProvinces,
    getEventLocations
};
